<template>
  <div class="plhksqMyApply">
    <Header title="我的缓考申请"></Header>
    <div class="delay-search">
      <i class="search-icon"></i>
      <input type="text" placeholder="搜索课程(名称或课号)" v-model="value" />
    </div>
    <div class="search-info">
      <div class="sem-drop">
        <div @click="showPop('学年学期', 'xnxq')">
          <p>{{ xnxq.mc }}</p>
          <i></i>
        </div>
        <div @click="showPop('审核状态', 'shzt')">
          <p>{{ shzt.mc }}</p>
          <i></i>
        </div>
        <div @click="showPop('活动名称', 'hdmc')">
          <p>{{ hdmc.mc }}</p>
          <i></i>
        </div>
      </div>
    </div>
    <NOdata title="未查询到缓考申请~" v-if="this.list.length == 0"></NOdata>
    <template v-else>
      <a
        class="grey-contain"
        v-for="(item, index) in list"
        :key="index"
        @click="select(item)"
      >
        <div>
          <p class="contain-txt">{{ item.courseName }}</p>
          <p class="contain-txt1">学年学期：{{ item.xqmc }}</p>
          <p class="contain-txt1">申请门数：{{ item.sqms }}</p>
          <p class="contain-txt1">缓考原因：{{ item.hkyy }}</p>
          <p class="contain-txt1">申请时间：{{ item.sqsj }}</p>
        </div>
        <p :class="returnClass(item.shzt)">
          {{ item.shzt }}
        </p>
      </a>
    </template>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      value: "",
      xnxq: {},
      shzt: {},
      hdmc: {},
      list: "",
      show: false,
      columns: {
        jxzcXq: [],
        jc: []
      },
      valueList: {
        label: "",
        value: "",
        item: []
      }
    };
  },
  created() {
    this.getMain();
  },
  methods: {
    select(item) {
      if (item.shzt === "待送审") {
        this.$router.push({
          path: "/plhksq/apply",
          query: {
            flag: 1,
            search: JSON.stringify({
              xnxq: this.xnxq,
              hdmc: this.hdmc
            }),
            list: JSON.stringify(item)
          }
        });
      } else {
        this.$router.push({
          path: "/plhksq/detail",
          search: JSON.stringify({
            xnxq: this.xnxq,
            hdmc: this.hdmc
          }),
          query: {
            data: JSON.stringify(item)
          }
        });
      }
    },
    returnClass(shzt) {
      switch (shzt) {
        case "不通过":
          return "btgClass";
        case "待送审":
          return "dssClass";
        case "审核中":
          return "shzClass";
        default:
          return "ytgClass";
      }
    },
    async getMain() {
      const res = await Api.getCurrentTerm();
      this.xnxq = {
        mc: res.data[0].semesterName,
        dm: res.data[0].semesterId
      };
      this.getXnxq();
    },
    async getList() {
      const res = await Api.getMySlowExamination({
        semester: this.xnxq.dm,
        courseName: this.value,
        cj0701id: this.hdmc.dm,
        shzt: this.shzt.dm
      });
      if (res.code == "1") {
        this.list = res.data;
      }
    },
    // 弹出选择器
    showPop(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value[0].text;
      this[value1].dm = value[0].value;
      this.getList();
    },
    async getXnxq() {
      let xnxqIndex = 0;
      const res = await Api.getSemesterList();
      this.columns.xnxq = [
        {
          values: res.data.map((item, index) => {
            if (this.xnxq.dm == item.semesterId) {
              xnxqIndex = index;
            }
            return {
              text: item.semesterName,
              value: item.semesterId
            };
          }),
          defaultIndex: xnxqIndex
        }
      ];
      this.columns.shzt = [
        {
          values: [
            {
              text: "审核状态",
              value: ""
            },
            {
              text: "不通过",
              value: "0"
            },
            {
              text: "通过",
              value: "1"
            },
            {
              text: "审核中",
              value: "2"
            },
            {
              text: "待送审",
              value: "3"
            },
            {
              text: "部分通过",
              value: "7"
            }
          ]
        }
      ];
      this.shzt = {
        dm: "",
        mc: "审核状态"
      };

      this.getHdmc();
    },
    async getHdmc() {
      const res = await Api.getActivityName({
        semester: this.xnxq.dm
      });
      this.columns.hdmc = [
        {
          values: res.data.map((item, index) => {
            if (index == 0) {
              this.hdmc = {
                mc: item.ACTIVITYNAME,
                dm: item.CJ0701ID
              };
            }
            return {
              text: item.ACTIVITYNAME,
              value: item.CJ0701ID
            };
          })
        }
      ];
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.plhksqMyApply {
  .delay-search {
    background-color: @attendance-background-color-6;
    border-radius: 3px;
    margin: 20px 20px 0;
    padding: 11px 12px;
    display: flex;
    .search-icon {
      background: url(../../../../../static/img/search.png) no-repeat center;
      width: 22px;
      height: 22px;
      background-size: 22px 22px;
    }
    input {
      background-color: @attendance-background-color-6;
      padding-left: 22px;
      flex: 1;
      color: @attendance-color-2;
    }
  }
  .search-info {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid @attendance-border-color-6;
    padding: 20px 0 7px;
    .sem-drop {
      display: flex;
      justify-content: space-between;
      width: 90%;
      > div {
        position: relative;
        width: 30%;
        display: flex;
        align-items: center;
        color: @attendance-color-2;
        font-size: 14px;
        justify-content: space-between;
        padding-right: 10px;
        box-sizing: border-box;
        p {
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        &:last-child {
          width: 35%;
        }
        i {
          position: absolute;
          background: url(../../../../../static/img/Triangle.png) no-repeat
            center;
          right: 5px;
          top: 5px;
          width: 10px;
          height: 10px;
          background-size: 10px 8px;
          margin-left: 5px;
        }
      }
    }
  }
  .grey-contain {
    padding: 20px;
    > p {
      font-size: 14px;
      font-weight: 500;
    }
    .shzClass {
      color: #7469f8 !important;
    }
    .btgClass {
      color: #f86969 !important;
    }
    .ytgClass {
      color: #12ddd6 !important;
    }
    .dssClass {
      color: #757da3 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/plhksq/myApply.vue